(() => {
  'use strict';

  const PRODUCT_HANDLE = 'peela-nails';
  const PRODUCT_URL = '/products/peela-nails';
  const MAX_TIER = 10;

  const ROOT =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  const TIERS = {
    0: {
      message:
        'Mix any sizes and shades. Add Peela polishes to unlock increasing discounts.',
      cta: 'Shop all shades',
      url: PRODUCT_URL
    },
    1: {
      message:
        "You're 1 bottle from 10% off. Mix any sizes — the discount grows with every bottle you add.",
      cta: 'Shop all shades',
      url: PRODUCT_URL
    },
    2: {
      message:
        "10% off applied. Add 1 more polish and you'll bump to 15% off your whole cart.",
      cta: 'Add 1 more',
      url: PRODUCT_URL
    },
    3: {
      message:
        "15% off applied. 1 more bottle unlocks 20% off — that's a fifth off everything.",
      cta: 'Add 1 more',
      url: PRODUCT_URL
    },
    4: {
      message:
        '20% off applied. Add 1 more polish to unlock 23% off.',
      cta: 'Add 1 more',
      url: PRODUCT_URL
    },
    5: {
      message:
        '23% off applied. Halfway to the full range — 1 more polish bumps you to 26% off.',
      cta: 'Add 1 more',
      url: PRODUCT_URL
    },
    6: {
      message:
        '26% off applied. Add 1 more bottle to unlock 29% off.',
      cta: 'Add 1 more',
      url: PRODUCT_URL
    },
    7: {
      message:
        '29% off applied. Add 1 more bottle to unlock 31% off.',
      cta: 'Add 1 more',
      url: PRODUCT_URL
    },
    8: {
      message:
        '31% off applied. Add 1 more bottle to unlock 33% off.',
      cta: 'Add 1 more',
      url: PRODUCT_URL
    },
    9: {
      message:
        "33% off applied. You're 1 bottle from the maximum 35% discount.",
      cta: 'Complete the set',
      url: PRODUCT_URL
    },
    10: {
      message:
        '35% off applied — maximum discount unlocked. Enjoy!',
      cta: 'Checkout',
      url: '/checkout'
    }
  };

  let refreshTimer = null;
  let isAdding = false;
  let isRefreshingSections = false;

  function getTier(count) {
    const safeCount = Math.min(
      Math.max(Number(count) || 0, 0),
      MAX_TIER
    );

    return TIERS[safeCount];
  }

  function getPeelaQuantity(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return 0;
    }

    return cart.items.reduce((total, item) => {
      return item.handle === PRODUCT_HANDLE
        ? total + (Number(item.quantity) || 0)
        : total;
    }, 0);
  }

  async function getCart() {
    const response = await fetch(`${ROOT}cart.js`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(
        `Unable to load cart: ${response.status}`
      );
    }

    return response.json();
  }

  function updateHeaderCount(count) {
    document
      .querySelectorAll('#CartDrawer .drawer__count')
      .forEach((element) => {
        element.textContent = String(count);

        element.setAttribute(
          'aria-label',
          `${count} item${count === 1 ? '' : 's'} in cart`
        );
      });
  }

  function updateCartBubble(count) {
    const cartIcon = document.getElementById(
      'cart-icon-bubble'
    );

    if (!cartIcon) {
      return;
    }

    let bubble = cartIcon.querySelector(
      '.cart-count-bubble'
    );

    if (count <= 0) {
      if (bubble) {
        bubble.remove();
      }

      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';

      bubble.innerHTML =
        '<span aria-hidden="true"></span>' +
        '<span class="visually-hidden"></span>';

      cartIcon.appendChild(bubble);
    }

    const visible = bubble.querySelector(
      'span[aria-hidden="true"]'
    );

    const hidden = bubble.querySelector(
      '.visually-hidden'
    );

    if (visible) {
      visible.textContent =
        count > 99 ? '99+' : String(count);
    }

    if (hidden) {
      hidden.textContent =
        `${count} item${count === 1 ? '' : 's'}`;
    }
  }

  function updateTier(cart) {
    const banner = document.getElementById(
      'PeelaCartTier'
    );

    if (!banner) {
      return;
    }

    const count = getPeelaQuantity(cart);
    const tier = getTier(count);

    banner.hidden = count === 0;

    banner
      .querySelectorAll('[data-tier-step]')
      .forEach((step) => {
        const stepNumber = Number(
          step.dataset.tierStep
        );

        step.classList.toggle(
          'is-filled',
          stepNumber <= Math.min(count, MAX_TIER)
        );
      });

    const message = banner.querySelector(
      '#PeelaCartTierMessage'
    );

    const cta = banner.querySelector(
      '#PeelaCartTierCta'
    );

    if (message) {
      message.textContent = tier.message;
    }

    if (cta) {
      cta.textContent = tier.cta;
      cta.href = tier.url;
    }
  }

  async function updateDynamicUI() {
    try {
      const cart = await getCart();

      updateHeaderCount(cart.item_count);
      updateCartBubble(cart.item_count);
      updateTier(cart);

      document.dispatchEvent(
        new CustomEvent('peela:cart-refreshed', {
          detail: { cart }
        })
      );
    } catch (error) {
      console.error(
        '[Peela cart UI]',
        error
      );
    }
  }

  function getSectionUrl() {
    const url = new URL(window.location.href);

    url.searchParams.set(
      'sections',
      'cart-drawer,cart-icon-bubble'
    );

    return url.toString();
  }

  function parseSection(html, selector) {
    if (!html) {
      return null;
    }

    const documentFragment =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    return documentFragment.querySelector(
      selector
    );
  }

  function isDrawerOpen() {
    const drawer =
      document.querySelector('cart-drawer');

    const drawerPanel =
      document.querySelector('#CartDrawer');

    return Boolean(
      drawer &&
      (
        drawer.classList.contains('active') ||
        drawerPanel?.classList.contains('active')
      )
    );
  }

  function replaceDrawerSection(html) {
    const replacement = parseSection(
      html,
      'cart-drawer'
    );

    const current =
      document.querySelector('cart-drawer');

    if (!replacement || !current) {
      return false;
    }

    /*
      Keep the existing cart-drawer element in place.

      Replacing the complete custom element removes its open state
      and causes the drawer to close and reopen visibly.

      Updating only the inner markup keeps the drawer continuously open.
    */
    const wasOpen = isDrawerOpen();

    const wasEmpty =
      replacement.classList.contains('is-empty');

    current.innerHTML = replacement.innerHTML;

    current.classList.toggle(
      'is-empty',
      wasEmpty
    );

    if (wasOpen) {
      current.classList.add('active');

      const drawerPanel =
        current.querySelector('#CartDrawer');

      if (drawerPanel) {
        drawerPanel.classList.add('active');
      }

      document.body.classList.add(
        'overflow-hidden'
      );
    }

    return true;
  }

  function replaceCartBubbleSection(html) {
    const replacement = parseSection(
      html,
      '#cart-icon-bubble'
    );

    const current = document.querySelector(
      '#cart-icon-bubble'
    );

    if (!replacement || !current) {
      return false;
    }

    current.replaceWith(replacement);

    return true;
  }

  function openDrawer() {
    const drawer =
      document.querySelector('cart-drawer');

    if (!drawer || isDrawerOpen()) {
      return;
    }

    requestAnimationFrame(() => {
      if (typeof drawer.open === 'function') {
        drawer.open();
      } else {
        drawer.classList.add('active');

        const drawerPanel =
          drawer.querySelector('#CartDrawer');

        if (drawerPanel) {
          drawerPanel.classList.add('active');
        }

        document.body.classList.add(
          'overflow-hidden'
        );
      }
    });
  }

  async function refreshRenderedSections(
    options = {}
  ) {
    if (isRefreshingSections) {
      return;
    }

    isRefreshingSections = true;

    try {
      const response = await fetch(
        getSectionUrl(),
        {
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!response.ok) {
        throw new Error(
          `Unable to refresh cart drawer: ${response.status}`
        );
      }

      const sections = await response.json();

      replaceDrawerSection(
        sections['cart-drawer']
      );

      replaceCartBubbleSection(
        sections['cart-icon-bubble']
      );

      await updateDynamicUI();
    } catch (error) {
      console.error(
        '[Peela cart sections]',
        error
      );

      await updateDynamicUI();
    } finally {
      isRefreshingSections = false;
    }
  }

  function scheduleRenderedRefresh(
    options = {}
  ) {
    clearTimeout(refreshTimer);

    refreshTimer = window.setTimeout(() => {
      refreshRenderedSections(options);
    }, options.delay || 120);
  }

  function getAddForm(eventTarget) {
    if (!(eventTarget instanceof Element)) {
      return null;
    }

    return eventTarget.closest(
      'form[action*="/cart/add"], form[action$="/cart/add"]'
    );
  }

  function getSubmitButton(form) {
    return form.querySelector(
      'button[name="add"], [type="submit"], .product-form__submit'
    );
  }

  function setLoading(button, loading) {
    if (!button) {
      return;
    }

    button.disabled = loading;

    button.setAttribute(
      'aria-disabled',
      loading ? 'true' : 'false'
    );

    button.classList.toggle(
      'loading',
      loading
    );
  }

  async function addProduct(form) {
    if (isAdding) {
      return;
    }

    isAdding = true;

    const drawerWasAlreadyOpen =
      isDrawerOpen();

    const submitButton =
      getSubmitButton(form);

    setLoading(submitButton, true);

    try {
      const formData = new FormData(form);

      formData.set(
        'sections',
        'cart-drawer,cart-icon-bubble'
      );

      formData.set(
        'sections_url',
        window.location.pathname
      );

      const response = await fetch(
        `${ROOT}cart/add.js`,
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        }
      );

      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(
          result.description ||
          result.message ||
          'This product could not be added to the cart.'
        );
      }

      if (result.sections) {
        replaceDrawerSection(
          result.sections['cart-drawer']
        );

        replaceCartBubbleSection(
          result.sections['cart-icon-bubble']
        );
      } else {
        await refreshRenderedSections();
      }

      await updateDynamicUI();

      /*
        Open the drawer only when it was closed before adding.

        When it is already open, it remains open continuously.
      */
      if (!drawerWasAlreadyOpen) {
        openDrawer();
      }

      document.dispatchEvent(
        new CustomEvent(
          'peela:product-added',
          {
            detail: {
              result
            }
          }
        )
      );
    } catch (error) {
      console.error(
        '[Peela add to cart]',
        error
      );

      window.alert(error.message);
    } finally {
      isAdding = false;

      setLoading(
        submitButton,
        false
      );
    }
  }

  function interceptProductForms() {
    document.addEventListener(
      'submit',
      (event) => {
        const form = getAddForm(
          event.target
        );

        if (!form) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        addProduct(form);
      },
      true
    );
  }

  function isCartMutationUrl(input) {
    const rawUrl =
      typeof input === 'string'
        ? input
        : input &&
          typeof input.url === 'string'
          ? input.url
          : '';

    if (!rawUrl) {
      return false;
    }

    try {
      const url = new URL(
        rawUrl,
        window.location.origin
      );

      return /\/cart\/(add|change|update|clear)(\.js)?$/.test(
        url.pathname
      );
    } catch (error) {
      return false;
    }
  }

  function interceptCartFetches() {
    if (
      window.__peelaRealtimeCartFetchInstalled
    ) {
      return;
    }

    window.__peelaRealtimeCartFetchInstalled =
      true;

    const originalFetch = window.fetch;

    window.fetch = async function (...args) {
      const response =
        await originalFetch.apply(
          this,
          args
        );

      /*
        The custom add request already renders immediately.

        Dawn quantity and remove requests trigger a section refresh,
        but the existing open cart-drawer element remains in place.
      */
      if (
        !isAdding &&
        !isRefreshingSections &&
        isCartMutationUrl(args[0])
      ) {
        scheduleRenderedRefresh({
          delay: 140
        });
      }

      return response;
    };
  }

  function bindOutsideDrawerClose() {
    if (window.__peelaDrawerOutsideCloseInstalled) {
      return;
    }

    window.__peelaDrawerOutsideCloseInstalled = true;

    document.addEventListener('click', function (event) {
      const overlay = event.target.closest('#CartDrawer-Overlay');

      if (!overlay) {
        return;
      }

      const drawer = overlay.closest('cart-drawer');

      if (drawer && typeof drawer.close === 'function') {
        drawer.close();
        return;
      }

      if (drawer) {
        drawer.classList.remove('active');

        const drawerPanel = drawer.querySelector('#CartDrawer');

        if (drawerPanel) {
          drawerPanel.classList.remove('active');
        }
      }

      document.body.classList.remove(
        'overflow-hidden'
      );
    });
  }

  function bindDawnEvents() {
    const refresh = () => {
      scheduleRenderedRefresh({
        delay: 100
      });
    };

    document.addEventListener(
      'cart:updated',
      refresh
    );

    document.addEventListener(
      'cart:refresh',
      refresh
    );

    document.addEventListener(
      'shopify:section:load',
      refresh
    );

    if (
      typeof window.subscribe === 'function' &&
      window.PUB_SUB_EVENTS &&
      window.PUB_SUB_EVENTS.cartUpdate
    ) {
      try {
        window.subscribe(
          window.PUB_SUB_EVENTS.cartUpdate,
          refresh
        );
      } catch (error) {
        console.warn(
          '[Peela cart] Dawn subscription failed.',
          error
        );
      }
    }
  }

  function initialize() {
    interceptProductForms();
    interceptCartFetches();
    bindOutsideDrawerClose();
    bindDawnEvents();
    updateDynamicUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      {
        once: true
      }
    );
  } else {
    initialize();
  }
})();